/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border-bold[_ngcontent-%COMP%]{border-bottom:2px solid #ccc!important}.box-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .box-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:4px}.months[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 5px;font-size:.8em}"];
export { styles as styles };
